import { useCallback } from "react";
import { CouponsApi, useAPIAction } from "melco-shared-logic";
import { EditCouponFormValueInterface } from "../../components/coupons/form/EditCouponForm";

export const useEditCoupon = () => {
  const [editCoupon] = useAPIAction(
    CouponsApi,
    async (api, CouponDetails: EditCouponFormValueInterface) => {
      const data = await api.couponsEdit({
        id: CouponDetails.id ?? "",
        controlcenterMelcoModelsCreateCoupon: {
          ...CouponDetails,
          product_code_list: CouponDetails.product_code
        }
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "coupons.actions.edit",
    }
  );

  return useCallback(
    async (couponLinkDetails: EditCouponFormValueInterface) => {
      try {
        await editCoupon(couponLinkDetails);
      } catch (e) {
        return { success: false };
      }

      return { success: true };
    },
    [editCoupon]
  );
};
